/**
 * @generated SignedSource<<2089b6be52ec23d49b1e798089f3874b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModuleVariant_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleCarouselVariant_user">;
  readonly " $fragmentType": "HpSharedFeaturedModuleVariant_user";
};
export type HpSharedFeaturedModuleVariant_user$key = {
  readonly " $data"?: HpSharedFeaturedModuleVariant_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleVariant_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModuleVariant_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedFeaturedModuleCarouselVariant_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "ad6d8a1fb58f8ab18284d3d4e0ec8f6c";

export default node;
